$(document).ready(function () {
    $(".block__test-drive-tab-slider-slider-wrapper").find('.block__test-drive-tab-slider-slide video').each(function (index, element) {
        if(!index == 0){
           element.pause()
           element.removeAttribute('autoplay'); 
        }
     });
  var $slider = $(".block__test-drive-tab-slider-slider-wrapper");

  // Initialize slick
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    fade: true
  });

  // Attach ended listener to each video inside the slider
  $slider.find('.block__test-drive-tab-slider-slide video').each(function () {
    this.addEventListener('ended', function () {
      const currentIndex = $slider.slick('slickCurrentSlide');
      const totalSlides = $slider.slick('getSlick').slideCount;
        console.log(currentIndex, "currentIndex", totalSlides, "totalSlides")
      if (currentIndex < totalSlides - 1) {
        $slider.slick('slickNext');
      } else {
        $slider.slick('slickGoTo', 0);
      }
    });
  });
  $slider.on('afterChange', function (event, slick, currentSlide) {
  const nextVideo = $(slick.$slides[currentSlide]).find('video')[0];
  if (nextVideo) {
    nextVideo.play();
  }
});
});
